module.exports = __webpack_public_path__ + "static/media/mausam - dust storm.89f1215d.png";